import React, { useState, useEffect, useContext, Suspense } from "react";
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import DehazeIcon from "@mui/icons-material/Dehaze";
import LanguageIcon from "@mui/icons-material/Language";
import InputAdornment from "@mui/material/InputAdornment";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import "./header.css";
import Amplify, { Auth, API } from "aws-amplify";
import LogoBlock from "./components/LogoBlock";
import * as AuthAPI from "../../../offline-auth/auth";
import { OffLineAPI } from "../../../offline-auth/api";
import { removeUserAccount } from "../../../containers/actions/profile";
import PlayCircleIcon from "@mui/icons-material/PlayCircleFilled";
import {
  LanguageContext,
  roleContext,
  PayloadContext,
  LicenseContext,
} from "../../../libs/context";
import { toast } from "react-toastify";
import ResponsiveSideNav from "../responsiveSideNav/index";
import { userFullName } from "./../../../libs/utils";
import StarIcon from "@mui/icons-material/Star";
import "../../../containers/ui-styles/avatarcircle/avatarcircle.css";
import deviceInfo from "../../../containers/confsimulcast/conference/msoup/deviceInfo";
import BottomNavigation from "../../../components/common/bottomNavigation/index";
const _Auth = JSON.parse(import.meta.env.VITE_isOffline) ? AuthAPI.Auth : Auth;
let _API = JSON.parse(import.meta.env.VITE_isOffline) ? OffLineAPI : API;

const Header = (props) => {
  const [dropDownMenu, setDropDownMenu] = useState(false);
  const [mobNav, setMobNav] = useState(false);
  const [mobShade, setMobShade] = useState(false);
  const history = useHistory();
  const device = deviceInfo();

  const handleClickOutside = (event) => {
    if (
      wrapperRef.current &&
      !wrapperRef.current.contains(event.target) &&
      (props.active || dropDownMenu)
    ) {
      setDropDownMenu(false);
      if (props.handleSideNav) {
        props.handleSideNav(false);
      }
    }
  };

  const wrapperRef = React.useRef(null);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropDownMenu]);

  const toggleDropDown = () => {
    setDropDownMenu(!dropDownMenu);
  };

  const setAwsconfig = async (subDomainData) => {
    Amplify.configure({
      Auth: {
        mandatorySignIn: true,
        region: JSON.parse(import.meta.env.VITE_cognito).REGION,
        userPoolId: subDomainData.poolId,
        identityPoolId: subDomainData.identityPoolId,
        userPoolWebClientId: subDomainData.appClientId,
      },
      Storage: {
        region: JSON.parse(import.meta.env.VITE_s3).REGION,
        bucket: JSON.parse(import.meta.env.VITE_s3).PROFILEBUCKET,
        identityPoolId: subDomainData.identityPoolId,
      },
      API: {
        endpoints: [
          {
            name: "insta",
            endpoint: JSON.parse(import.meta.env.VITE_apiGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiGateway).REGION,
            },
            {
            name: "domain",
            endpoint: JSON.parse(import.meta.env.VITE_apiDomainGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiDomainGateway).REGION,
            },
            {
            name: "mcu",
            endpoint: JSON.parse(import.meta.env.VITE_apiMcuGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiMcuGateway).REGION,
            },
            {
            name: "user",
            endpoint: JSON.parse(import.meta.env.VITE_apiUserGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiUserGateway).REGION,
            },
            {
            name: "plan",
            endpoint: JSON.parse(import.meta.env.VITE_apiPlanGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiPlanGateway).REGION,
            },
            {
            name: "coupon",
            endpoint: JSON.parse(import.meta.env.VITE_apiCouponGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiCouponGateway).REGION,
            },
            {
            name: "transaction",
            endpoint: JSON.parse(import.meta.env.VITE_apiTransactionGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiTransactionGateway).REGION,
            },
            {
            name: "referral",
            endpoint: JSON.parse(import.meta.env.VITE_apiReferralGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiReferralGateway).REGION,
            },
            {
            name: "recording",
            endpoint: JSON.parse(import.meta.env.VITE_apiRecordingGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiRecordingGateway).REGION,
            },
            {
            name: "mcu_recording",
            endpoint: JSON.parse(import.meta.env.VITE_apimcuRecordingGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apimcuRecordingGateway).REGION,
            },
            {
            name: "content",
            endpoint: JSON.parse(import.meta.env.VITE_apiContentGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiContentGateway).REGION,
            },
            {
            name: "schedule",
            endpoint: JSON.parse(import.meta.env.VITE_apiScheduleGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiScheduleGateway).REGION,
            },
            {
            name: "address",
            endpoint: JSON.parse(import.meta.env.VITE_apiAddressGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiAddressGateway).REGION,
            },
            {
            name: "multipart_upload",
            endpoint: JSON.parse(import.meta.env.VITE_apiMultipartUploadGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiMultipartUploadGateway).REGION,
            },
            {
            name: "meetings",
            endpoint: JSON.parse(import.meta.env.VITE_apiMeetingGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiMeetingGateway).REGION,
            },
            {
            name: "mail",
            endpoint: JSON.parse(import.meta.env.VITE_apiMailGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiMailGateway).REGION,
            },
            {
            name: "broadcast",
            endpoint: JSON.parse(import.meta.env.VITE_apiBroadcastGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiBroadcastGateway).REGION,
            },
            {
            name: "test",
            endpoint: JSON.parse(import.meta.env.VITE_apiTestGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiTestGateway).REGION,
            },
            {
            name: "doc_share",
            endpoint: JSON.parse(import.meta.env.VITE_apiDocumentShareGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiDocumentShareGateway).REGION,
            },
            {
            name: "chat",
            endpoint: JSON.parse(import.meta.env.VITE_apiChatGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiChatGateway).REGION,
            },
            {
            name: "admin",
            endpoint: JSON.parse(import.meta.env.VITE_apiAdminGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiAdminGateway).REGION,
            },
            {
            name: "inVCSchedule",
            endpoint: JSON.parse(import.meta.env.VITE_invcScheduleAPI).URL,
            region: JSON.parse(import.meta.env.VITE_invcScheduleAPI).REGION,
            },
            {
            name: "inVCEmail",
            endpoint: JSON.parse(import.meta.env.VITE_invcEmailAPI).URL,
            region: JSON.parse(import.meta.env.VITE_invcEmailAPI).REGION,
            },
            {
            name: "inVCLicense",
            endpoint: JSON.parse(import.meta.env.VITE_invcLicenseAPI).URL,
            region: JSON.parse(import.meta.env.VITE_invcLicenseAPI).REGION,
            },
            {
            name: "class",
            endpoint: JSON.parse(import.meta.env.VITE_apiClassCreateGateway).URL,
            region: JSON.parse(import.meta.env.VITE_apiClassCreateGateway).REGION,
            },
            {
            name: "inclassChat",
            endpoint: JSON.parse(import.meta.env.VITE_inclassChatAPI).URL,
            region: JSON.parse(import.meta.env.VITE_inclassChatAPI).REGION,
            },
            {
            name: "inClassMcu",
            endpoint: JSON.parse(import.meta.env.VITE_inclassMcuAPI).URL,
            region: JSON.parse(import.meta.env.VITE_inclassMcuAPI).REGION,
            },
            {
            name: "inClassReports",
            endpoint: JSON.parse(import.meta.env.VITE_inclassReportsAPI).URL,
            region: JSON.parse(import.meta.env.VITE_inclassReportsAPI).REGION,
            },
            {
            name: "inClassAssessments",
            endpoint: JSON.parse(import.meta.env.VITE_inclassAssessmentsAPI).URL,
            region: JSON.parse(import.meta.env.VITE_inclassAssessmentsAPI).REGION,
            },
            {
            name: "inaffiliateUser",
            endpoint: JSON.parse(import.meta.env.VITE_inaffiliateUserAPI).URL,
            region: JSON.parse(import.meta.env.VITE_inaffiliateUserAPI).REGION,
            },
        ],
      },
    });
  };

  const handleLogout = async (event) => {
    await _Auth.signOut();
    if (device.platform === 'mobile') {
      localStorage.removeItem('subDomain');
      setAwsconfig({
        poolId: JSON.parse(import.meta.env.VITE_cognito).USER_POOL_ID,
        identityPoolId: JSON.parse(import.meta.env.VITE_cognito).IDENTITY_POOL_ID,
        appClientId: JSON.parse(import.meta.env.VITE_cognito).APP_CLIENT_ID
      });
    }
    props.userHasAuthenticated(false, null);
    history.push("/");
  };

  const handleRemoveAccount = async (event) => {
    let language = languageContext;
    removeUserAccount().then(res => {
      if (res.status) {
        toast.success(language.account_del_succ, {
          position: toast.POSITION.TOP_RIGHT,
        });
        props.userHasAuthenticated(false, null);
        history.push("/");
      } else {
        toast.error(res?.response?.data?.error, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }).catch(err => {
      console.log("err ==== ", err);
      toast.error(err?.response?.data?.error, {
        position: toast.POSITION.TOP_RIGHT,
      });
    });
  };

  const handleOpenSideNav = () => {
        props.handleSideNav(true);
  };

 const handleSlideIn = () => {
    setMobNav(true);
    setMobShade(true);
  };

  const handleSlideOut = () => {
    setMobNav(false);
    setMobShade(false);
  };

  const langselect = (event) => {
    const langValue = event.target.value;
    props.setLanguage(langValue);
  };

  const languageContext = useContext(LanguageContext);
  const payloadContext = useContext(PayloadContext);
  const roleContextValue = useContext(roleContext);
  const lang = localStorage.getItem("setLang") || props.setLang;

  return (
    <div className="flexRow header alignCntr">
      {payloadContext.payload?.expiryAt < new Date().valueOf() ? null : 
      <>
      <div
        className="displayOrNot mrgRight"
        onClick={handleSlideIn}
        ref={wrapperRef}
      >
        <DehazeIcon />
      </div>
      <div className="mobileView">
        <BottomNavigation />
      </div>
      </>
      }
      <ResponsiveSideNav
        mobNav={mobNav}
        mobShade={mobShade}
        handleSlideOut={handleSlideOut}
        handleLogout={handleLogout}
        handleRemoveAccount={handleRemoveAccount}
      />
      <LogoBlock logo={props.webLogo} />
      <div className='flexIline1 callBtn desDisrNot'>
        <a className='tollfree flexIline1 alignCntr' href="https://help.instavc.com/inclass" target="_blank">
          <PlayCircleIcon className='callIcon invertWhite' fontSize='small' />{languageContext.help_Center}
        </a>
      </div>
      <div className='flexIline1 callBtn mobDisrNotHeder'>
        <a className='tollfree flexIline1 alignCntr' href="https://help.instavc.com/inclass" target="_blank">
          <PlayCircleIcon className='callIcon invertWhite' fontSize='small' />{languageContext.instavc_settings_help}
        </a>
      </div>
      <div className="flexAutoRow">
        <TextField
          size="small"
          className="langInput"
          select
          value={lang}
          onChange={langselect}
          name="langselect"
          variant="outlined"
          inputProps={{ className: "langInputSelect" }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className="nomrg">
                <LanguageIcon />
              </InputAdornment>
            ),
          }}
        >
          <MenuItem value="en">English</MenuItem>
          <MenuItem value="fr">français</MenuItem>
          <MenuItem value="hi">हिन्दी</MenuItem>
          <MenuItem value="it">Italiana</MenuItem>
          <MenuItem value="pt">português</MenuItem>
          <MenuItem value="es">Española</MenuItem>
        </TextField>

        <div
          className="headerAvatarBlock"
          onClick={toggleDropDown}
          ref={wrapperRef}
        >
          <Suspense fallback={<div>{languageContext.header_loading}</div>}>
            <div className="userName pdng8">
              <span className="hideInMobile capitalizeTxt">
                {userFullName(payloadContext.payload)}
              </span>
            </div>
            <div className="userAvatar">
              <div className="badgeBox whiteBadge">
                <StarIcon color="secondary" fontSize="small" style={{ fontSize: "1.0rem" }} />
              </div>
              <img
                src={payloadContext.payload?.profileImage?.url || "/images/icons/default-gray-user-avatar.png"}
                alt="Profile"
                loading="lazy"
              />
            </div>
            <div className={dropDownMenu ? "headerAvaDrpDwn show" : "headerAvaDrpDwn"}>
              <LicenseContext.Consumer>
                {(licensectx) => (
                  <ul>
                    {payloadContext.payload?.expiryAt < new Date().valueOf() ? null : 
                    <>
                      <li>
                        <Link to="/myprofile?value=profile">
                          {languageContext.instavc_dashboard_myprofile}
                        </Link>
                      </li>
                      <li>
                        <Link to="/settings">
                          {languageContext.instavc_dashboard_settings}
                        </Link>
                      </li>
                      {payloadContext.payload?.role === "Admin" && (
                        <li>
                          <Link to="/manage-licenses">
                            {languageContext.instavc_admin_licenses}
                          </Link>
                        </li>
                      )}
                    </>
                    }
                    <li>
                      <span onClick={handleLogout } className="logout">
                        {languageContext.instavc_dashboard_logout}
                      </span>
                    </li>
                  </ul>
                )}
              </LicenseContext.Consumer>
            </div>
          </Suspense>
        </div>
      </div>
    </div>
  );
};

export default Header;